import socketIOClient from "socket.io-client";

const ENDPOINT = "https://devhivee.herokuapp.com/";

const socket = socketIOClient(ENDPOINT);

export default socket;